<template>
  <section class="not-found" :class="{ loaded: pageLoaded }">

    <div class="glow"></div>

    <div class="container">

      <!-- VISUAL -->
      <div class="visual">

        <div class="number">
          404
        </div>

        <img
          src="/images/NotFound.jpg"
          alt="Página no encontrada"
          loading="lazy"
          decoding="async"
        />

      </div>

      <!-- CONTENT -->
      <div class="content">

        <span class="badge">
          Error de navegación
        </span>

        <h1>
          No encontramos esta página
        </h1>

        <p>
          Es posible que el enlace haya cambiado, se haya eliminado
          o que la URL esté escrita incorrectamente.
        </p>

        <div class="actions">

          <router-link to="/" class="btn primary">
            Ir al inicio
          </router-link>

          <router-link to="/servicios" class="btn secondary">
            Explorar servicios
          </router-link>

        </div>

      </div>

    </div>

  </section>
</template>

<script>
export default {
  name: "NotFoundComponent",

  data() {
    return {
      pageLoaded: false
    };
  },

  mounted() {
    requestAnimationFrame(() => {
      this.pageLoaded = true;
    });
  }
};
</script>

<style scoped>

/* ===== BASE ===== */
.not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4rem 1.5rem;

  background: #f8fafc;

  opacity: 0;
  transform: translateY(20px);
  transition: all .9s ease;
}

.not-found.loaded {
  opacity: 1;
  transform: translateY(0);
}

/* ===== GLOW BACKGROUND ===== */
.glow {
  position: absolute;
  width: 600px;
  height: 600px;

  background: radial-gradient(
    circle,
    rgba(15,118,110,.15),
    transparent 60%
  );

  filter: blur(40px);

  top: -200px;
  right: -200px;

  z-index: 0;
}

/* ===== CONTAINER ===== */
.container {
  position: relative;
  z-index: 1;

  max-width: 1100px;
  width: 100%;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;

  align-items: center;
}

/* ===== VISUAL ===== */
.visual {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0;
  transform: translateY(25px);
  transition: all .9s ease;
}

.loaded .visual {
  opacity: 1;
  transform: translateY(0);
}

.number {
  position: absolute;

  font-size: 8rem;
  font-weight: 800;

  color: #e2e8f0;

  letter-spacing: -4px;

  z-index: 0;
}

.visual img {
  width: 100%;
  max-width: 380px;

  position: relative;
  z-index: 1;

  transform: translateY(0);
  animation: float 4s ease-in-out infinite;
}

/* ===== CONTENT ===== */
.content {
  opacity: 0;
  transform: translateY(25px);
  transition: all .9s ease .1s;
}

.loaded .content {
  opacity: 1;
  transform: translateY(0);
}

.badge {
  display: inline-block;

  padding: .4rem 1rem;
  border-radius: 999px;

  background: rgba(15,118,110,.1);
  color: #0f766e;

  font-weight: 600;
  font-size: .85rem;

  margin-bottom: 1rem;
}

h1 {
  font-size: clamp(2.2rem, 4vw, 3rem);
  color: #0f172a;

  margin-bottom: 1rem;
}

p {
  color: #475569;
  line-height: 1.8;

  margin-bottom: 2rem;
}

/* ===== ACTIONS ===== */
.actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn {
  padding: 0.9rem 1.4rem;
  border-radius: 14px;

  font-weight: 700;
  text-decoration: none;

  transition: all .25s ease;
}

.btn:hover {
  transform: translateY(-3px);
}

.primary {
  background: linear-gradient(135deg, #0f766e, #065f46);
  color: white;

  box-shadow: 0 10px 25px rgba(15,118,110,.25);
}

.secondary {
  background: white;
  color: #0f172a;

  border: 1px solid #e2e8f0;
}

/* ===== ANIMATION ===== */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {

  .container {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 2.5rem;
  }

  .actions {
    justify-content: center;
  }

  .number {
    font-size: 6rem;
  }
}

</style>